module.exports = __webpack_public_path__ + "static/img/icon-item.62c32a2c.png";